import React from "react";
import ReactExport from "react-export-excel";
import { Button } from "antd";
import dateFormat from "dateformat";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Excelldownload = ({ data, selectedkeys, allData }) => {
  let exportData;
  const dataArray = data.results || [];

  if (allData) {
    exportData = dataArray;
  } else {
    exportData = dataArray.filter((el) => selectedkeys.includes(el.id));
  }

  // Format dates
  exportData = exportData.map((item) => ({
    ...item,
    special_dates: item.special_dates ? dateFormat(item.special_dates, "yyyy-mm-dd") : null,
  }));

  return (
    <ExcelFile
      element={
        <Button type="primary">
          {allData ? "Download All Contacts" : "Download Selected Contacts"}
        </Button>
      }
    >
      <ExcelSheet data={exportData} name="Contacts">
        <ExcelColumn label="Phone" value="phone" />
        <ExcelColumn label="Type" value="Role" />
        <ExcelColumn label="Name" value="name" />
        <ExcelColumn label="Address" value="address" />
      </ExcelSheet>
    </ExcelFile>
  );
};

export default Excelldownload;